import React from 'react';

export const demos = {
};
export const frontmatter = {"title":"Props","toc":"menu","filename":"src/Button/index.$tab-api.md"};
export const toc = [];
export const texts = [];
